// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__LnTBb","errorPage":"ErrorPage_errorPage__s66aQ"};